/**
 * @generated SignedSource<<71a54d98a3a637a009dbd16eb80ce257>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenameMarketingEmailInput = {
  id: string;
  name: string;
};
export type MarketingEmailViewRenameMutation$variables = {
  input: RenameMarketingEmailInput;
};
export type MarketingEmailViewRenameMutation$data = {
  readonly renameMarketingEmail: {
    readonly id: string;
    readonly name: string;
  };
};
export type MarketingEmailViewRenameMutation = {
  response: MarketingEmailViewRenameMutation$data;
  variables: MarketingEmailViewRenameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarketingEmail",
    "kind": "LinkedField",
    "name": "renameMarketingEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailViewRenameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarketingEmailViewRenameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc100e185aff0354269b084560da7c38",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailViewRenameMutation",
    "operationKind": "mutation",
    "text": "mutation MarketingEmailViewRenameMutation(\n  $input: RenameMarketingEmailInput!\n) {\n  renameMarketingEmail(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "11e7377e3c5a203cf89963c0347cc316";

export default node;
